import SearchIsActive from "./search_is_active"
import { inspirationInflections } from "@/lib/utils"

export default function PhotoFilterPillBar(props) {
  const filterMapping = (key) => {
    return {
      'application_categories_id_eq': props.application_categories,
      'application_spaces_id_eq': props.space_filters,
      'tags_id_eq': props.product_type_filters,
      'photos_application_categories_id_eq': props.application_categories,
      'photos_application_spaces_id_eq': props.space_filters,
      'photos_product_hot_spots_product_tags_id_eq': props.product_type_filters
    }[key]
  }

  const clearResults = () => {
    if(props.searchAppPhotos)
      props.searchAppPhotos({});
    if(props.searchGalleries)
      props.searchGalleries({});
    props.searchState.clearAll();
  }

  const formatSearchRemoveQ = (search) => {
    let newSearch = {}
    Object.keys(search).forEach((key) => {
      let newKey = key.replace('q[', '').replace(']', '')
      newSearch[newKey] = search[key]
    });
    return newSearch;
  }

  const formatKeyInsertQ = (key) => {
    let newKey = "q[" + key + "]"
    return newKey;
  }

  let currentSearch = formatSearchRemoveQ(props.searchState.search);

  const searchActive = SearchIsActive(props.filters, currentSearch);

  const buildFilterPills = () => {
    let filters = [];
    Object.keys(currentSearch).forEach((search) => {
      if(currentSearch[search] && !['s', 'is_new_true', 'created_at_gt'].includes(search)){
        let list = filterMapping(search) || []
        let filter = list.find((v, i) => v.id == currentSearch[search] ) 
        if (filter){
          filters.push({...filter, type: search});
        }
      }
    })
    if(currentSearch['product_hot_spots_product_id_eq']){
      let filter = {}
      filter['id'] = currentSearch['product_hot_spots_product_id_eq']
      filter['name'] = props.contained_product_name
      filter['type'] = 'product_hot_spots_product_id_eq'
      filters.push(filter);
    }
    return (filters.map((filter, i) => {
      return (<div className='inspiration-filter-pill' key={i}>
        <div className='inspiration-filter-pill-text'>{filter.name}</div>
        <div className='inspiration-remove-filter-icon' onClick={() => { props.searchState.removeKey(formatKeyInsertQ(filter.type)) }}>x</div>
      </div>);
    }));
  }

  return (<div className='lexcms-query-container'>
    <p className='query-text'>Showing {props.total_count} {inspirationInflections(props.resourceName, props.total_count)}:</p>
    { (searchActive || currentSearch['product_hot_spots_product_id_eq']) &&
    <>
      <div className='lexcms-inspiration-filter-pills-container'>
        { buildFilterPills() }
      </div>
      <a className='lexcms-clear-photos-button' 
        onClick={ clearResults }>Clear All Results</a>
    </>
    }
  </div>
  )
}